import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "./common/Footer";
import SEO from "./SEO";

const Locations = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (window.AOS) window.AOS.init();
  }, []);

  const renderTemplate = (locationId, templateID) => {
    navigate(`location/${locationId}/${templateID}/menu`);
  };

  return (
    <>
      <SEO
        title="Bowinkles Drive Thru | Local Fast Food Drive Thru in Rancho Cordova and Rio Linda"
        description="Bowinkles Drive Thru offers delicious fast food in Sacramento area. Choose from our Rio Linda or Rancho Cordova locations. Order burgers, sandwiches, Mexican food, wings, and more!"
        keywords="Bowinkles Drive Thru, fast food Rancho Cordova, fast food Rio Linda, Sacramento fast food, drive thru restaurant, burgers, wings, Mexican food, local restaurant"
        image="/images/bowinklesfoodcover.jpeg"
      />
      <div className="locationsContainer">
        <div className="container-fluid" id="locationHeader">
          <h1 className="text-center">Bowinkles Drive Thru</h1>
        </div>
      <div className="container-fluid" id="pushTop">
        <div className="textHeader text-center">
          <h1>Please Choose a Location</h1>
          <div className="row justify-content-center">
            <div
              className="col-md-5 riolinda"
              data-aos="fade-right"
              onClick={() => renderTemplate("Rio-Linda", 1)}
            >
              <div className="overlay">
                <div className="content">
                  <h2>Rio Linda Location</h2>
                </div>
              </div>
            </div>
            <div
              className="col-md-5 rancho"
              data-aos="fade-left"
              onClick={() => renderTemplate("Rancho-Cordova", 2)}
            >
              <div className="overlay">
                <div className="content">
                  <h2>Rancho Cordova Location</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
    </>
  );
};

export default Locations;
